import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button } from '@/components/ui/daisy/button';
import { useAppShell } from '@/data/context/AppShellContext';

type ShellLogoutButtonVariant = 'expanded' | 'compact';

type ShellLogoutButtonProps = {
  variant?: ShellLogoutButtonVariant;
};

export default function ShellLogoutButton({
  variant = 'expanded',
}: ShellLogoutButtonProps) {
  const { logout } = useAppShell();
  const { t } = useTranslation('translation', {
    keyPrefix: 'appShell.sidebar',
  });

  return (
    <ConditionalRenderer
      condition={variant === 'compact'}
      fallback={
        <Button
          color="error"
          variant="soft"
          className="w-full"
          onClick={logout}
        >
          {t('logout')}
          <ArrowRightStartOnRectangleIcon className="size-3.5" />
        </Button>
      }
    >
      <Button
        variant="ghost"
        shape="square"
        className="text-error"
        aria-label={t('logout')}
        onClick={logout}
      >
        <ArrowRightStartOnRectangleIcon className="size-6" />
      </Button>
    </ConditionalRenderer>
  );
}
